import React from 'react'
import { useEffect, useCallback } from 'react'
import instance from '../../utils/req'
import { useUrlQuery } from '../../utils/useFunc'
import { useState } from 'react'
import {Toast} from 'antd-mobile'
import { getUrl } from '../../utils/tool'

function useCreactFrom (member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode) {
  // let {servicestoken, servicesuid, real_price, goods_id, goods_type, payment_code, channel_new } = useUrlQuery()
  return useCallback(async () => {
    if (!member_id || !goods_id || !sku_id || !object_type || !is_deduction || !channel || !appId || !channel_new || !appcode) {
      throw new Error("创建订单参数错误")
    }
    let data =  await instance({
      method:'post',
      url:'https://service.agent.pro.caixuetang.cn?c=buy&a=creatorder&v=user&site=pay',
      data:{
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        goods_id,
        sku_id,
        object_type,
        is_deduction,
        channel,
        appId,
        channel_new,
        appcode,
      }
    })
    return data
  }, [member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode])
}



function usePayFrom (member_id, appcode) {
  // let {servicestoken, servicesuid } = useUrlQuery()
  return useCallback(async (pay_sn) => {
    if (!member_id || !appcode) {
      throw new Error("获取支付配置失败")
    }
    const data = await instance({
      method: 'post',
      url:
        'https://service.agent.pro.caixuetang.cn?c=Payment&a=pay&v=user&site=pay',
      data: {
        channel: 'h5',
        payment_code: 'wxpay_gz',
        mchid_type:1,
        appcode,
        pay_sn,
        member_id: localStorage.getItem('member_id'),key: localStorage.getItem('key'),client_type:'h5',
        openid_code: getUrl(window.location.search, 'code')
      }
    })
    return data
  },[member_id, appcode])
}
// 确认支付
function usePayWXFunc(CreactFrom, PayFrom,appcode) {
  return useCallback(async (pay_sn) => {
      try {
        let pay_snData = (await CreactFrom()).data
        let Info = (await PayFrom(pay_snData.pay_sn)).data
        return Info
      } catch (error) {
        throw new Error(error.message)
      }
  }, [CreactFrom, PayFrom,appcode])
}
// 获取微信回调链接的参数
function getRedirectUrl ( member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode) {
  // let {servicestoken, servicesuid, real_price, goods_id, goods_type, payment_code, channel_new } = useUrlQuery()
  if (!member_id || !goods_id || !sku_id || !object_type || !is_deduction || !channel || !appId || !channel_new || !appcode) {
    return ''
  } else {
    return encodeURIComponent(
      `${window.location.origin}${window.location.pathname}#/wxpay?stat=2&member_id=${member_id}&sku_id=${sku_id}&object_type=${object_type}&goods_id=${goods_id}&is_deduction=${is_deduction}&channel=${channel}&channel_new=${channel_new}&appId=${appId}&appcode=${appcode}`
    )
  }
}
const onBridgeReady = (data) => {
  /* if (typeof data === 'string') {
    data = JSON.parse(data)
  } */
  // eslint-disable-next-line
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      appId: data.appId, //公众号名称，由商户传入
      timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
      nonceStr: data.nonceStr, //随机串
      package: data.package,
      signType: data.signType, //微信签名方式：
      paySign: data.paySign //微信签名
    },
    function (res) {
      console.log(res,'res');
      if (res.err_msg == 'get_brand_wcpay_request:ok') {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        window.location.href = `${window.location.origin}/act1033/index.html#/result`
      } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
        sessionStorage.setItem('payshow',true)
        Toast.fail('支付取消,回到首页', 1)
        if(sessionStorage.getItem('url') === 'p1'){
          window.location.href = `${window.location.origin}/act1033/index.html#/p1`+"?sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')
        }else if(sessionStorage.getItem('url') === 'p2'){
          window.location.href = `${window.location.origin}/act1033/index.html#/p2`+"?sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')
        }else {
          window.location.href = `${window.location.origin}/act1033/index.html#/p3`+"?sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')
        }
      } else {
        sessionStorage.setItem('payshow',true)
        Toast.fail('支付失败,回到首页', 1)
        if(sessionStorage.getItem('url') === 'p1'){
          window.location.href = `${window.location.origin}/act1033/index.html#/p1`+"?sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')
        }else if(sessionStorage.getItem('url') === 'p2'){
          window.location.href = `${window.location.origin}/act1033/index.html#/p2`+"?sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')
        }else {
          window.location.href = `${window.location.origin}/act1033/index.html#/p3`+"?sku_id=" + localStorage.getItem('sku_id') + "&qudao=" + localStorage.getItem('channel')
        }
      }
    }
  )
}



export default () => {
  let { stat, member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode } = useUrlQuery()
  let redirectUrl = getRedirectUrl( member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode)
  let CreactFrom = useCreactFrom(member_id, goods_id, sku_id, object_type, is_deduction, channel, appId, channel_new, appcode)
  let PayFrom = usePayFrom(member_id, appcode)
  let [code] = useState(() => getUrl(window.location.search, 'code'))
  let [appID] = useState('wx7cd07332ff654dd6') // 旧
  // let [appID] = useState('wx5fa37878b5c1cd1c')
  let [payInfo, setPayInfo] = useState(null)
  let payWXFunc = usePayWXFunc(CreactFrom,PayFrom, appcode)

  // 绑定支付事件
  useEffect(() => {
    if (payInfo) {
      if (typeof WeixinJSBridge == 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else {
        onBridgeReady(payInfo)
      }
    }
    return () => {
      if (payInfo) {
        document.removeEventListener('WeixinJSBridgeReady', onBridgeReady)
      }
    }
  }, [payInfo])
  // 跳转获取code
  if (stat == 1&&redirectUrl) {
    // 获取code
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appID}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=2#wechat_redirect`
    return <div></div>
  }
  // 支付
  useEffect(() => {
    if (stat == 2) {
      // 获取openid
      if (code) {
        payWXFunc()
        .then(payInfo => setPayInfo(payInfo))
        .catch(error => {
          Toast.fail(`获取openid失败，请重试 ${error.message}`)
        })
      }
    }
  }, [stat,code, payWXFunc])
  return <div></div>
}
